import { useState, useEffect, useRef } from 'react';
import css from './CountryCodeDropdown.module.css';

import { ReactComponent as ArrowUp } from './CountryFlagIcons/ArrowUp.svg';
import { ReactComponent as ArrowDown } from './CountryFlagIcons/ArrowDown.svg';

// Import SVG flags for 200 countries (example of a few countries)
import AFFlag from './CountryFlagIcons/Country=AF.svg';
import ALFlag from './CountryFlagIcons/Country=AL.svg';
import DZFlag from './CountryFlagIcons/Country=DZ.svg';
import ADFlag from './CountryFlagIcons/Country=AD.svg';
import AOFlag from './CountryFlagIcons/Country=AO.svg';
import ARFlag from './CountryFlagIcons/Country=AR.svg';
import AMFlag from './CountryFlagIcons/Country=AM.svg';
import AUFlag from './CountryFlagIcons/Country=AU.svg';
import ATFlag from './CountryFlagIcons/Country=AT.svg';
import AZFlag from './CountryFlagIcons/Country=AZ.svg';
import BSFlag from './CountryFlagIcons/Country=BS.svg';
import BHFlag from './CountryFlagIcons/Country=BH.svg';
import BDFlag from './CountryFlagIcons/Country=BD.svg';
import BBFlag from './CountryFlagIcons/Country=BB.svg';
import BYFlag from './CountryFlagIcons/Country=BY.svg';
import BEFlag from './CountryFlagIcons/Country=BE.svg';
import BZFlag from './CountryFlagIcons/Country=BZ.svg';
import BJFlag from './CountryFlagIcons/Country=BJ.svg';
import BOFlag from './CountryFlagIcons/Country=BO.svg';
import BAFlag from './CountryFlagIcons/Country=BA.svg';
import BWFlag from './CountryFlagIcons/Country=BW.svg';
import BRFlag from './CountryFlagIcons/Country=BR.svg';
import BGFlag from './CountryFlagIcons/Country=BG.svg';
import BFFlag from './CountryFlagIcons/Country=BF.svg';
import BIFlag from './CountryFlagIcons/Country=BI.svg';
import CVFlag from './CountryFlagIcons/Country=CV.svg';
import KHFlag from './CountryFlagIcons/Country=KH.svg';
import CMFlag from './CountryFlagIcons/Country=CM.svg';
import CAFlag from './CountryFlagIcons/Country=CA.svg';
import CFFlag from './CountryFlagIcons/Country=CF.svg';
import TDFlag from './CountryFlagIcons/Country=TD.svg';
import CLFlag from './CountryFlagIcons/Country=CL.svg';
import CNFlag from './CountryFlagIcons/Country=CN.svg';
import COFlag from './CountryFlagIcons/Country=CO.svg';
import KMFlag from './CountryFlagIcons/Country=KM.svg';
import CGFlag from './CountryFlagIcons/Country=CG.svg';
import CDFlag from './CountryFlagIcons/Country=CD.svg';
import CRFlag from './CountryFlagIcons/Country=CR.svg';
import HRFlag from './CountryFlagIcons/Country=HR.svg';
import CUFlag from './CountryFlagIcons/Country=CU.svg';
import CYFlag from './CountryFlagIcons/Country=CY.svg';
import CZFlag from './CountryFlagIcons/Country=CZ.svg';
import DKFlag from './CountryFlagIcons/Country=DK.svg';
import DJFlag from './CountryFlagIcons/Country=DJ.svg';
import DMFlag from './CountryFlagIcons/Country=DM.svg';
import DOFlag from './CountryFlagIcons/Country=DO.svg';
import ECFlag from './CountryFlagIcons/Country=EC.svg';
import EGFlag from './CountryFlagIcons/Country=EG.svg';
import SVFlag from './CountryFlagIcons/Country=SV.svg';
import GQFlag from './CountryFlagIcons/Country=GQ.svg';
import ERFlag from './CountryFlagIcons/Country=ER.svg';
import EEFlag from './CountryFlagIcons/Country=EE.svg';
import ETFlag from './CountryFlagIcons/Country=ET.svg';
import FJFlag from './CountryFlagIcons/Country=FJ.svg';
import FIFlag from './CountryFlagIcons/Country=FI.svg';
import FRFlag from './CountryFlagIcons/Country=FR.svg';
import GAFlag from './CountryFlagIcons/Country=GA.svg';
import GMFlag from './CountryFlagIcons/Country=GM.svg';
import GEFlag from './CountryFlagIcons/Country=GE.svg';
import DEFlag from './CountryFlagIcons/Country=DE.svg';
import GHFlag from './CountryFlagIcons/Country=GH.svg';
import GRFlag from './CountryFlagIcons/Country=GR.svg';
import GDFlag from './CountryFlagIcons/Country=GD.svg';
import GTFlag from './CountryFlagIcons/Country=GT.svg';
import GNFlag from './CountryFlagIcons/Country=GN.svg';
import GWFlag from './CountryFlagIcons/Country=GW.svg';
import GYFlag from './CountryFlagIcons/Country=GY.svg';
import HTFlag from './CountryFlagIcons/Country=HT.svg';
import HNFlag from './CountryFlagIcons/Country=HN.svg';
import HUFlag from './CountryFlagIcons/Country=HU.svg';
import ISFlag from './CountryFlagIcons/Country=IS.svg';
import INFlag from './CountryFlagIcons/Country=IN.svg';
import IDFlag from './CountryFlagIcons/Country=ID.svg';
import IRFlag from './CountryFlagIcons/Country=IR.svg';
import IQFlag from './CountryFlagIcons/Country=IQ.svg';
import IEFlag from './CountryFlagIcons/Country=IE.svg';
import ILFlag from './CountryFlagIcons/Country=IL.svg';
import ITFlag from './CountryFlagIcons/Country=IT.svg';
import CIFlag from './CountryFlagIcons/Country=CI.svg';
import JMFlag from './CountryFlagIcons/Country=JM.svg';
import JPFlag from './CountryFlagIcons/Country=JP.svg';
import JOFlag from './CountryFlagIcons/Country=JO.svg';
import KZFlag from './CountryFlagIcons/Country=KZ.svg';
import KEFlag from './CountryFlagIcons/Country=KE.svg';
import KRFlag from './CountryFlagIcons/Country=KR.svg';
import KWFlag from './CountryFlagIcons/Country=KW.svg';
import LAFlag from './CountryFlagIcons/Country=LA.svg';
import LVFlag from './CountryFlagIcons/Country=LV.svg';
import LBFlag from './CountryFlagIcons/Country=LB.svg';
import LSFlag from './CountryFlagIcons/Country=LS.svg';
import LRFlag from './CountryFlagIcons/Country=LR.svg';
import LYFlag from './CountryFlagIcons/Country=LY.svg';
import LTFlag from './CountryFlagIcons/Country=LT.svg';
import LUFlag from './CountryFlagIcons/Country=LU.svg';
import MGFlag from './CountryFlagIcons/Country=MG.svg';
import MWFlag from './CountryFlagIcons/Country=MW.svg';
import MYFlag from './CountryFlagIcons/Country=MY.svg';
import MXFlag from './CountryFlagIcons/Country=MX.svg';
import MAFlag from './CountryFlagIcons/Country=MA.svg';
import MZFlag from './CountryFlagIcons/Country=MZ.svg';
import NAFlag from './CountryFlagIcons/Country=NA.svg';
import NPFlag from './CountryFlagIcons/Country=NP.svg';
import NLFlag from './CountryFlagIcons/Country=NL.svg';
import NZFlag from './CountryFlagIcons/Country=NZ.svg';
import NIFlag from './CountryFlagIcons/Country=NI.svg';
import NEFlag from './CountryFlagIcons/Country=NE.svg';
import NGFlag from './CountryFlagIcons/Country=NG.svg';
import NOFlag from './CountryFlagIcons/Country=NO.svg';
import OMFlag from './CountryFlagIcons/Country=OM.svg';
import PKFlag from './CountryFlagIcons/Country=PK.svg';
import PAFlag from './CountryFlagIcons/Country=PA.svg';
import PGFlag from './CountryFlagIcons/Country=PG.svg';
import PYFlag from './CountryFlagIcons/Country=PY.svg';
import PEFlag from './CountryFlagIcons/Country=PE.svg';
import PHFlag from './CountryFlagIcons/Country=PH.svg';
import PLFlag from './CountryFlagIcons/Country=PL.svg';
import PTFlag from './CountryFlagIcons/Country=PT.svg';
import QAFlag from './CountryFlagIcons/Country=QA.svg';
import ROFlag from './CountryFlagIcons/Country=RO.svg';
import RUFlag from './CountryFlagIcons/Country=RU.svg';
import RWFlag from './CountryFlagIcons/Country=RW.svg';
import SAFlag from './CountryFlagIcons/Country=SA.svg';
import SNFlag from './CountryFlagIcons/Country=SN.svg';
import RSFlag from './CountryFlagIcons/Country=RS.svg';
import SCFlag from './CountryFlagIcons/Country=SC.svg';
import SLFlag from './CountryFlagIcons/Country=SL.svg';
import SGFlag from './CountryFlagIcons/Country=SG.svg';
import SKFlag from './CountryFlagIcons/Country=SK.svg';
import SIFlag from './CountryFlagIcons/Country=SI.svg';
import SBFlag from './CountryFlagIcons/Country=SB.svg';
import SOFlag from './CountryFlagIcons/Country=SO.svg';
import ZAFlag from './CountryFlagIcons/Country=ZA.svg';
import ESFlag from './CountryFlagIcons/Country=ES.svg';
import LKFlag from './CountryFlagIcons/Country=LK.svg';
import SDFlag from './CountryFlagIcons/Country=SD.svg';
import SRFlag from './CountryFlagIcons/Country=SR.svg';
import SZFlag from './CountryFlagIcons/Country=SZ.svg';
import SEFlag from './CountryFlagIcons/Country=SE.svg';
import CHFlag from './CountryFlagIcons/Country=CH.svg';
import SYFlag from './CountryFlagIcons/Country=SY.svg';
import TWFlag from './CountryFlagIcons/Country=TW.svg';
import TJFlag from './CountryFlagIcons/Country=TJ.svg';
import TZFlag from './CountryFlagIcons/Country=TZ.svg';
import THFlag from './CountryFlagIcons/Country=TH.svg';
import TLFlag from './CountryFlagIcons/Country=TL.svg';
import TGFlag from './CountryFlagIcons/Country=TG.svg';
import TOFlag from './CountryFlagIcons/Country=TO.svg';
import TTFlag from './CountryFlagIcons/Country=TT.svg';
import TNFlag from './CountryFlagIcons/Country=TN.svg';
import TRFlag from './CountryFlagIcons/Country=TR.svg';
import TMFlag from './CountryFlagIcons/Country=TM.svg';
import UGFlag from './CountryFlagIcons/Country=UG.svg';
import UAFlag from './CountryFlagIcons/Country=UA.svg';
import AEFlag from './CountryFlagIcons/Country=AE.svg';
import GBFlag from './CountryFlagIcons/Country=GB.svg';
import USFlag from './CountryFlagIcons/Country=US.svg';
import UYFlag from './CountryFlagIcons/Country=UY.svg';
import UZFlag from './CountryFlagIcons/Country=UZ.svg';
import VUFlag from './CountryFlagIcons/Country=VU.svg';
import VEFlag from './CountryFlagIcons/Country=VE.svg';
import VNFlag from './CountryFlagIcons/Country=VN.svg';
import YEFlag from './CountryFlagIcons/Country=YE.svg';
import ZMFlag from './CountryFlagIcons/Country=ZM.svg';
import ZWFlag from './CountryFlagIcons/Country=ZW.svg';
import AGFlag from './CountryFlagIcons/Country=AG.svg';
import BTFlag from './CountryFlagIcons/Country=BT.svg';
import BNFlag from './CountryFlagIcons/Country=BN.svg';
import KGFlag from './CountryFlagIcons/Country=KG.svg';
import MVFlag from './CountryFlagIcons/Country=MV.svg';
import MRFlag from './CountryFlagIcons/Country=MR.svg';
import MUFlag from './CountryFlagIcons/Country=MU.svg';
import MDFlag from './CountryFlagIcons/Country=MD.svg';
import MCFlag from './CountryFlagIcons/Country=MC.svg';
import MNFlag from './CountryFlagIcons/Country=MN.svg';
import MEFlag from './CountryFlagIcons/Country=ME.svg';
import MMFlag from './CountryFlagIcons/Country=MM.svg';
import KPFlag from './CountryFlagIcons/Country=KP.svg';
import PWFlag from './CountryFlagIcons/Country=PW.svg';
import KNFlag from './CountryFlagIcons/Country=KN.svg';
import LCFlag from './CountryFlagIcons/Country=LC.svg';
import VCFlag from './CountryFlagIcons/Country=VC.svg';
import WSFlag from './CountryFlagIcons/Country=WS.svg';
import SMFlag from './CountryFlagIcons/Country=SM.svg';
import MLFlag from './CountryFlagIcons/Country=ML.svg';
import MTFlag from './CountryFlagIcons/Country=MT.svg';
import PFFlag from './CountryFlagIcons/Country=PF.svg';
import BMFlag from './CountryFlagIcons/Country=BM.svg';
import MSFlag from './CountryFlagIcons/Country=MS.svg';
import AIFlag from './CountryFlagIcons/Country=AI.svg';
import IMFlag from './CountryFlagIcons/Country=IM.svg';



const countryCodes = [
  { key: '+93', label: 'Afghanistan', flag: AFFlag },
  { key: '+355', label: 'Albania', flag: ALFlag },
  { key: '+213', label: 'Algeria', flag: DZFlag },
  { key: '+376', label: 'Andorra', flag: ADFlag },
  { key: '+244', label: 'Angola', flag: AOFlag },
  { key: '+1-264', label: 'Anguilla', flag: AIFlag },
  { key: '+1-268', label: 'Antigua and Barbuda', flag: AGFlag },
  { key: '+54', label: 'Argentina', flag: ARFlag },
  { key: '+374', label: 'Armenia', flag: AMFlag },
  { key: '+61', label: 'Australia', flag: AUFlag },
  { key: '+43', label: 'Austria', flag: ATFlag },
  { key: '+994', label: 'Azerbaijan', flag: AZFlag },
  { key: '+1-242', label: 'Bahamas', flag: BSFlag },
  { key: '+973', label: 'Bahrain', flag: BHFlag },
  { key: '+880', label: 'Bangladesh', flag: BDFlag },
  { key: '+1-246', label: 'Barbados', flag: BBFlag },
  { key: '+375', label: 'Belarus', flag: BYFlag },
  { key: '+32', label: 'Belgium', flag: BEFlag },
  { key: '+501', label: 'Belize', flag: BZFlag },
  { key: '+1-441', label: 'Bermuda ', flag: BMFlag },
  { key: '+229', label: 'Benin', flag: BJFlag },
  { key: '+975', label: 'Bhutan', flag: BTFlag },
  { key: '+591', label: 'Bolivia', flag: BOFlag },
  { key: '+387', label: 'Bosnia and Herzegovina', flag: BAFlag },
  { key: '+267', label: 'Botswana', flag: BWFlag },
  { key: '+55', label: 'Brazil', flag: BRFlag },
  { key: '+673', label: 'Brunei', flag: BNFlag },
  { key: '+359', label: 'Bulgaria', flag: BGFlag },
  { key: '+226', label: 'Burkina Faso', flag: BFFlag },
  { key: '+257', label: ' Burundi', flag: BIFlag },
  { key: '+855', label: 'Cambodia', flag: KHFlag },
  { key: '+237', label: 'Cameroon', flag: CMFlag },
  { key: '+1', label: 'Canada', flag: CAFlag },
  { key: '+238', label: 'Cape Verde', flag: CVFlag },
  { key: '+236', label: 'Central African Republic', flag: CFFlag },
  { key: '+235', label: 'Chad', flag: TDFlag },
  { key: '+56', label: 'Chile', flag: CLFlag },
  { key: '+86', label: 'China', flag: CNFlag },
  { key: '+57', label: 'Colombia', flag: COFlag },
  { key: '+269', label: 'Comoros', flag: KMFlag },
  { key: '+243', label: 'Congo (DRC)', flag: CDFlag },
  { key: '+242', label: 'Congo (Republic)', flag: CGFlag },
  { key: '+506', label: 'Costa Rica', flag: CRFlag },
  { key: '+385', label: 'Croatia', flag: HRFlag },
  { key: '+53', label: 'Cuba', flag: CUFlag },
  { key: '+357', label: 'Cyprus', flag: CYFlag },
  { key: '+420', label: 'Czech Republic', flag: CZFlag },
  { key: '+45', label: 'Denmark', flag: DKFlag },
  { key: '+253', label: 'Djibouti', flag: DJFlag },
  { key: '+1-767', label: 'Dominica', flag: DMFlag },
  { key: '+1-809', label: 'Dominican Republic', flag: DOFlag },
  { key: '+593', label: 'Ecuador', flag: ECFlag },
  { key: '+20', label: 'Egypt', flag: EGFlag },
  { key: '+503', label: 'El Salvador', flag: SVFlag },
  { key: '+240', label: 'Equatorial Guinea', flag: GQFlag },
  { key: '+291', label: 'Eritrea', flag: ERFlag },
  { key: '+372', label: 'Estonia', flag: EEFlag },
  { key: '+251', label: 'Ethiopia', flag: ETFlag },
  { key: '+679', label: 'Fiji', flag: FJFlag },
  { key: '+358', label: 'Finland', flag: FIFlag },
  { key: '+33', label: 'France', flag: FRFlag },
  { key: '+689', label: ' French Polynesia', flag: PFFlag },
  { key: '+241', label: 'Gabon', flag: GAFlag },
  { key: '+220', label: 'Gambia', flag: GMFlag },
  { key: '+995', label: 'Georgia', flag: GEFlag },
  { key: '+49', label: 'Germany', flag: DEFlag },
  { key: '+233', label: 'Ghana', flag: GHFlag },
  { key: '+30', label: 'Greece', flag: GRFlag },
  { key: '+1-473', label: 'Grenada', flag: GDFlag },
  { key: '+502', label: 'Guatemala', flag: GTFlag },
  { key: '+224', label: 'Guinea', flag: GNFlag },
  { key: '+245', label: 'Guinea-Bissau', flag: GWFlag },
  { key: '+592', label: 'Guyana', flag: GYFlag },
  { key: '+509', label: 'Haiti', flag: HTFlag },
  { key: '+504', label: 'Honduras', flag: HNFlag },
  { key: '+36', label: 'Hungary', flag: HUFlag },
  { key: '+354', label: 'Iceland', flag: ISFlag },
  { key: '+91', label: 'India', flag: INFlag },
  { key: '+62', label: 'Indonesia', flag: IDFlag },
  { key: '+98', label: 'Iran', flag: IRFlag },
  { key: '+964', label: 'Iraq', flag: IQFlag },
  { key: '+353', label: 'Ireland', flag: IEFlag },
  { key: '+972', label: 'Israel', flag: ILFlag },
  { key: '+44-1624', label: 'Isle of Man', flag: IMFlag },
  { key: '+39', label: 'Italy', flag: ITFlag },
  { key: '+225', label: 'Ivory Coast', flag: CIFlag },
  { key: '+1-876', label: 'Jamaica', flag: JMFlag },
  { key: '+81', label: 'Japan', flag: JPFlag },
  { key: '+962', label: 'Jordan', flag: JOFlag },
  { key: '+7', label: 'Kazakhstan', flag: KZFlag },
  { key: '+254', label: 'Kenya', flag: KEFlag },
  { key: '+965', label: 'Kuwait', flag: KWFlag },
  { key: '+996', label: 'Kyrgyzstan', flag: KGFlag },
  { key: '+856', label: 'Laos', flag: LAFlag },
  { key: '+371', label: 'Latvia', flag: LVFlag },
  { key: '+961', label: 'Lebanon', flag: LBFlag },
  { key: '+266', label: 'Lesotho', flag: LSFlag },
  { key: '+231', label: 'Liberia', flag: LRFlag },
  { key: '+218', label: 'Libya', flag: LYFlag },
  { key: '+370', label: 'Lithuania', flag: LTFlag },
  { key: '+352', label: 'Luxembourg ', flag: LUFlag },
  { key: '+261', label: 'Madagascar', flag: MGFlag },
  { key: '+265', label: 'Malawi', flag: MWFlag },
  { key: '+60', label: 'Malaysia', flag: MYFlag },
  { key: '+960', label: 'Maldives', flag: MVFlag },
  { key: '+223', label: 'Mali', flag: MLFlag },
  { key: '+356', label: 'Malta', flag: MTFlag },
  { key: '+222', label: 'Mauritania', flag: MRFlag },
  { key: '+230', label: 'Mauritius', flag: MUFlag },
  { key: '+52', label: 'Mexico', flag: MXFlag },
  { key: '+373', label: 'Moldova', flag: MDFlag },
  { key: '+377', label: 'Monaco', flag: MCFlag },
  { key: '+976', label: 'Mongolia', flag: MNFlag },
  { key: '+382', label: 'Montenegro', flag: MEFlag },
  { key: '+1-664', label: 'Montserrat', flag: MSFlag },
  { key: '+212', label: 'Morocco', flag: MAFlag },
  { key: '+258', label: 'Mozambique', flag: MZFlag },
  { key: '+95', label: 'Myanmar', flag: MMFlag },
  { key: '+264', label: 'Namibia', flag: NAFlag },
  { key: '+977', label: 'Nepal', flag: NPFlag },
  { key: '+31', label: 'Netherlands', flag: NLFlag },
  { key: '+64', label: 'New Zealand', flag: NZFlag },
  { key: '+505', label: 'Nicaragua', flag: NIFlag },
  { key: '+227', label: 'Niger', flag: NEFlag },
  { key: '+234', label: 'Nigeria', flag: NGFlag },
  { key: '+850', label: 'North Korea', flag: KPFlag },
  { key: '+47', label: 'Norway', flag: NOFlag },
  { key: '+968', label: 'Oman', flag: OMFlag },
  { key: '+92', label: 'Pakistan', flag: PKFlag },
  { key: '+680', label: 'Palau', flag: PWFlag },
  { key: '+507', label: 'Panama', flag: PAFlag },
  { key: '+675', label: 'Papua New Guinea', flag: PGFlag },
  { key: '+595', label: 'Paraguay', flag: PYFlag },
  { key: '+51', label: 'Peru', flag: PEFlag },
  { key: '+63', label: 'Philippines', flag: PHFlag },
  { key: '+48', label: 'Poland', flag: PLFlag },
  { key: '+351', label: 'Portugal', flag: PTFlag },
  { key: '+974', label: 'Qatar', flag: QAFlag },
  { key: '+40', label: 'Romania', flag: ROFlag },
  { key: '+7', label: 'Russia', flag: RUFlag },
  { key: '+250', label: 'Rwanda', flag: RWFlag },
  { key: '+1-869', label: 'Saint Kitts and Nevis', flag: KNFlag },
  { key: '+1-758', label: 'Saint Lucia', flag: LCFlag },
  { key: '+1-784', label: 'Saint Vincent and the Grenadines', flag: VCFlag },
  { key: '+685', label: 'Samoa', flag: WSFlag },
  { key: '+378', label: 'San Marino', flag: SMFlag },
  { key: '+966', label: 'Saudi Arabia', flag: SAFlag },
  { key: '+221', label: 'Senegal', flag: SNFlag },
  { key: '+381', label: 'Serbia', flag: RSFlag },
  { key: '+248', label: 'Seychelles', flag: SCFlag },
  { key: '+232', label: 'Sierra Leone', flag: SLFlag },
  { key: '+65', label: 'Singapore', flag: SGFlag },
  { key: '+421', label: 'Slovakia', flag: SKFlag },
  { key: '+386', label: 'Slovenia', flag: SIFlag },
  { key: '+677', label: 'Solomon Islands', flag: SBFlag },
  { key: '+252', label: 'Somalia', flag: SOFlag },
  { key: '+27', label: 'South Africa', flag: ZAFlag },
  { key: '+82', label: 'South Korea', flag: KRFlag },
  { key: '+34', label: 'Spain', flag: ESFlag },
  { key: '+94', label: 'Sri Lanka', flag: LKFlag },
  { key: '+249', label: 'Sudan', flag: SDFlag },
  { key: '+597', label: 'Suriname', flag: SRFlag },
  { key: '+268', label: 'Swaziland', flag: SZFlag },
  { key: '+46', label: 'Sweden', flag: SEFlag },
  { key: '+41', label: 'Switzerland', flag: CHFlag },
  { key: '+963', label: 'Syria', flag: SYFlag },
  { key: '+886', label: 'Taiwan', flag: TWFlag },
  { key: '+992', label: 'Tajikistan', flag: TJFlag },
  { key: '+255', label: 'Tanzania', flag: TZFlag },
  { key: '+66', label: 'Thailand', flag: THFlag },
  { key: '+670', label: 'Timor-Leste', flag: TLFlag },
  { key: '+228', label: 'Togo', flag: TGFlag },
  { key: '+676', label: 'Tonga', flag: TOFlag },
  { key: '+1-868', label: 'Trinidad and Tobago', flag: TTFlag },
  { key: '+216', label: 'Tunisia', flag: TNFlag },
  { key: '+90', label: 'Turkey', flag: TRFlag },
  { key: '+993', label: 'Turkmenistan', flag: TMFlag },
  { key: '+256', label: 'Uganda', flag: UGFlag },
  { key: '+380', label: 'Ukraine', flag: UAFlag },
  { key: '+971', label: 'United Arab Emirates', flag: AEFlag },
  { key: '+44', label: 'United Kingdom', flag: GBFlag },
  { key: '+1', label: 'United States', flag: USFlag },
  { key: '+598', label: 'Uruguay', flag: UYFlag },
  { key: '+998', label: 'Uzbekistan', flag: UZFlag },
  { key: '+678', label: 'Vanuatu', flag: VUFlag },
  { key: '+58', label: 'Venezuela', flag: VEFlag },
  { key: '+84', label: 'Vietnam', flag: VNFlag },
  { key: '+967', label: 'Yemen', flag: YEFlag },
  { key: '+260', label: 'Zambia', flag: ZMFlag },
  { key: '+263', label: 'Zimbabwe', flag: ZWFlag },
];

const CountryCodeDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const fullValue = value ? countryCodes.find(i => i.key == value) : null;
  // Default selected country (USA)
  const [selectedCountry, setSelectedCountry] = useState(
    fullValue || { key: '+1', label: 'United States', flag: USFlag }
  );

  const handleSelect = (country) => {
    setSelectedCountry(country);
    setIsOpen(false);

    if (onChange) {
      onChange(country.key);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);
  return (
    <div className={css.dropdownContainer} ref={dropdownRef}>
      <div className={css.dropdownHeader} onClick={() => setIsOpen(!isOpen)}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={selectedCountry.flag}
            alt={selectedCountry.label}
            className={css.flag}
            style={{ marginRight: '8px' }}
          />
          {selectedCountry.key}
        </div>
        <span className={css.arrow}>{isOpen ? <ArrowUp /> : <ArrowDown />}</span>
      </div>

      {isOpen && (
        <ul className={css.dropdownList}>
          {countryCodes.map((country, index) => (
            <li
              key={index}
              className={css.dropdownItem}
              onClick={() => handleSelect(country)}
            >
              <img src={country.flag} alt={country.label} className={css.flag} />
              {country.key} {country.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CountryCodeDropdown;